import FieldModel from '@models/map/FieldModel';
import Form       from '@widesk-ui/components/form/Form';
import Input      from '@widesk-ui/components/form/Input';
import View       from '@widesk-ui/components/View';

export type FieldReferenceFormProps = {
	model: FieldModel;
	onSuccess?: () => void;
};

/**
 * La seule référence d'un champ, rien d'autre.
 *
 * Distinct de `FieldForm`, qui reste le formulaire complet (titre, nature, référence) utilisé à la
 * création et depuis la liste des champs du projet. Ici, on arrive depuis la fiche d'un type, où le
 * titre se modifie déjà en place dans la ligne et où la nature est arrêtée au moment de la création
 * — il ne reste donc à régler que la référence, l'identifiant stable par lequel le champ est désigné
 * de l'extérieur.
 */
export default function FieldReferenceForm(props: FieldReferenceFormProps) {
	return (
		<Form
			onSuccess={props.onSuccess}
			onDidMount={async formTools => {
				formTools.setFieldsValue({ reference: props.model.reference });
			}}
			fields={{
				reference: {
					label: 'Référence',
					element: <Input placeholder="Référence" />,
					// Espacement et interligne posés à la main : `extra` colle l'explication sous l'input
					// tout en gardant l'interligne large du corps de texte, ce qui donne un bloc à la fois
					// serré en haut et aéré à l'intérieur.
					extra: (
						<View mt={6} size="small" style={{ lineHeight: 1.45 }}>
							Identifiant stable par lequel ce {FieldModel.localize('default', 'l')} est désigné
							de l'extérieur — export, intégration. Le titre, lui, se modifie directement dans la liste.
						</View>
					),
					span: 24,
				},
			}}
			continueAfterSubmit={false}
			onSubmit={async values => {
				await props.model.patch({ reference: values.reference });

				return props.model;
			}}
		/>
	);
}
